export default "/dist/files/icone_monnaie.20234d4629b292317fddad0be34265b6.svg";